var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4282 5.11222L14.4285 5.11186C14.5583 4.98212 14.7667 4.98212 14.8964 5.11186C15.0178 5.23327 15.0178 5.45002 14.8964 5.57142L10.8214 9.64642L10.4679 9.99998L10.8214 10.3535L14.8964 14.4285C15.0262 14.5583 15.0262 14.7667 14.8964 14.8964C14.7667 15.0262 14.5583 15.0262 14.4285 14.8964L10.3535 10.8214L9.99998 10.4679L9.64642 10.8214L5.57142 14.8964C5.44168 15.0262 5.23327 15.0262 5.10353 14.8964C4.97379 14.7667 4.97379 14.5583 5.10353 14.4285L9.17853 10.3535L9.53208 9.99998L9.17853 9.64642L5.10353 5.57142C4.97379 5.44168 4.97379 5.23327 5.10353 5.10353C5.23327 4.97379 5.44168 4.97379 5.57142 5.10353L9.64642 9.17853L9.99961 9.53172L10.3532 9.17889L14.4282 5.11222Z",
    fill: "#2B8C34",
    stroke: "#2B8C34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearGreen);
export default __webpack_public_path__ + "static/media/clear_green.0017b0f7166a54526e523e0a43dbb306.svg";
export { ForwardRef as ReactComponent };